
let DashBoardModel = {
    sum: 0,
    count: 0,
    mean: 0,
    median: 0,
    std: 0
}

export default DashBoardModel;